import React, { useState, useRef } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Turnstile from 'react-turnstile';
import { useAuth } from '../context/AuthContext';
import './Login.css';

function Login() {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState('');
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const turnstileRef = useRef(null);

  // Redirect if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(credentials.username, credentials.password, turnstileToken);

    if (result.success) {
      if (result.mustChangePassword) {
        navigate('/change-password');
      } else {
        navigate('/dashboard');
      }
    } else {
      if (result.rateLimited) {
        setError('Too many login attempts. Please wait a moment and try again.');
      } else {
        setError(result.message || 'Login failed. Please check your credentials.');
      }
      setLoading(false);

      // Reset Turnstile widget on failed login
      setTurnstileToken('');
      if (turnstileRef.current) {
        turnstileRef.current.reset();
      }
    }
  };

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>Pest Patrol</h1>
          <p>Employee Login</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={credentials.username}
              onChange={handleChange}
              required
              autoFocus
              disabled={loading}
              placeholder="Enter username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              required
              disabled={loading}
              placeholder="Enter password"
            />
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', margin: '0.5rem 0' }}>
            <Turnstile
              ref={turnstileRef}
              sitekey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
              onVerify={(token) => setTurnstileToken(token)}
              onError={() => setTurnstileToken('')}
              onExpire={() => setTurnstileToken('')}
            />
          </div>

          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Log In'}
          </button>
        </form>

        <div className="login-footer">
          <small>Mike's Pest Patrol Business Management</small>
        </div>
      </div>
    </div>
  );
}

export default Login;
